import React, { useRef } from "react";
import Button from "@material-ui/core/Button";

export const BackendButton = (props) => {
  const ref = useRef();
  const auth = JSON.parse(localStorage["admin.usr"]);
  const domain = reloansysConfig.backendAdminAuthBaseUrl;

  return (
    <React.Fragment>
      <Button variant="contained" onClick={() => _openBackendView()}>
        {props.label}
      </Button>
      <div style={{ display: "none" }}>
        <form
          ref={ref}
          target="_blank"
          action={domain + "/auth/signin_from_token"}
          method="post"
        >
          <input type="text" name="token" value={auth.access_token} readOnly />
          <input type="text" name="redirect" value={props.url} readOnly />
        </form>
      </div>
    </React.Fragment>
  );

  function _openBackendView() {
    const form = ref.current;
    form.submit();
  }
};
